import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class GlobService {
  emode: boolean = false // edit mode
  hmode: boolean = false // help mode
  dmode: boolean = false // debug mode
  domain: string = location.protocol + '//' + location.host + '/'
  url: string = location.protocol + '//' + location.host + location.pathname // without parameters
  host: string = location.protocol + '//' + (location.port ? location.host.replace(location.port, (parseInt(location.port) + 1) + '') : location.host + ':8081') + '/'
  config: any = { theme: 'darko', chart_theme: 'darko' }
  themes_css: string[] = ['bootstrap-theme', 'bootstrap-modifier', 'font', 'struct', 'menu', 'page', 'login', 'grid', 'formy', 'chart', 'infocard', 'desktop']
  session: any = null
  comps: any = []
  profile: { name: string, family: string, user_name: string } = { name: 'کاربر', family: 'میهمان', user_name: '' }
  themes = []

  constructor() { }

  themer(thm: string): void {
    // if (thm == this.config.theme ) return
    if (thm) this.config.theme = thm

    // -- remove all theme css ---------
    for (let t of this.themes_css) {
      var element = document.getElementById('theme_' + t)
      if (element) element.parentNode.removeChild(element)
    }

    // -- add all theme css ------------
    if (this.config.theme != 'base')
      for (let t of this.themes_css) {
        var link = document.createElement('link')
        link.id = 'theme_' + t
        link.rel = 'stylesheet'
        link.href = `assets/themes/${this.config.theme}/css/${t}.css`
        document.getElementById('theme_base_' + t).appendChild(link)
      }
  }
}